export default __webpack_public_path__ + "static/media/modelS.d0943a6c.png";